<template>
  <div>
    <el-card>
      <div slot="header" class="font-bold">提现历史</div>
      <el-form :inline="true" size="small">
        <el-form-item label="状态">
          <el-select v-model="status" placeholder="全部" clearable @change="fetch">
            <el-option label="待处理" value="pending" /><el-option label="已打款" value="paid" /><el-option label="已驳回" value="rejected" />
          </el-select>
        </el-form-item>
        <el-form-item><el-button type="primary" @click="fetch">筛选</el-button></el-form-item>
      </el-form>
      <el-table :data="list" v-loading="loading" size="small">
        <el-table-column prop="bloggerName" label="博主" width="120" />
        <el-table-column prop="amount" label="金额" width="100"><template slot-scope="{row}">¥{{ row.amount }}</template></el-table-column>
        <el-table-column prop="alipayAccount" label="支付宝" width="180" />
        <el-table-column prop="realName" label="姓名" width="80" />
        <el-table-column label="状态" width="80">
          <template slot-scope="{row}">
            <el-tag :type="row.status==='paid'?'success':row.status==='rejected'?'danger':'warning'" size="small">
              {{ row.status==='paid'?'已打款':row.status==='rejected'?'已驳回':'待处理' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="rejectReason" label="驳回理由" width="150" show-overflow-tooltip />
        <el-table-column prop="remark" label="备注" width="120" show-overflow-tooltip />
        <el-table-column label="创建时间" width="160"><template slot-scope="{row}">{{ formatDate(row.createdAt) }}</template></el-table-column>
        <el-table-column label="处理时间" width="160"><template slot-scope="{row}">{{ formatDate(row.processedAt) }}</template></el-table-column>
      </el-table>
      <el-pagination style="margin-top:16px;text-align:right" background layout="total,prev,pager,next"
        :total="total" :page-size="size" :current-page.sync="page" @current-change="fetch" />
    </el-card>
  </div>
</template>

<script>
import { withdrawApi } from '../api';

export default {
  data() {
    return { list: [], page: 1, size: 10, total: 0, loading: false, status: '' };
  },
  created() { this.fetch(); },
  methods: {
    async fetch() {
      this.loading = true;
      const res = await withdrawApi.all({ page: this.page, size: this.size, status: this.status || undefined });
      this.list = res.data.list;
      this.total = res.data.total;
      this.loading = false;
    },
    formatDate(d) {
      if (!d) return '';
      return new Date(d).toLocaleString('zh-CN');
    }
  }
};
</script>
